﻿import { Component, EventEmitter, Output } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Department } from "../../models/department.model";
import { CredentialsResponse } from "../../models/login.model";
import { DataService } from "../../services/dataService";
import { HorizontalTextBoxComponent } from "../../shared/horizontalTextbox/horizontaltextBox.component";
import { TextBoxComponent } from "../../shared/Textbox/textBox.component";
import { ValidationBase } from "../../validation/validationBase";
import { ValidationMessage } from "../../validation/validationMessage";
import { ValidationMessageType } from "../../validation/validationMessageType";
import { EmailValidator } from "../../validation/validators/emailValidator";
import { ValidatorTuple } from "../../validation/validators/iValidator";


@Component({
    selector: "jax-ExternalUsersignup",
    templateUrl: "./ExternalUserSignup.component.html",
})
export class ExternalUserSignupComponent extends ValidationBase {
    public user: any = {};
    public iNotifyError;
    public validators = [];
    public department = Number;
    public hasSuccess: boolean = false;
    public validationMessage: ValidationMessage;
    public departments: Department[] = [];
    public response: any;

    constructor(private dataService: DataService, private router: Router, private activateRoute: ActivatedRoute) {
        super();
        this.validators.push(new ValidatorTuple(new EmailValidator(), this));
        this.iNotifyError = this;
        this.user.department = this.departments[0];
    }

    public ngOnInit() {
        this.activateRoute
            .queryParams
            .subscribe((params) => {
                this.user.Token = params["id"];
                return this.checkToken();
            });
    }

    public signUp() {
        this.validate()
            .subscribe((s) => {
                if (!this.isValid) {
                    return;
                }
                if (this.validateSecurityQuestionAndAnswer()) {
                    let msg = new ValidationMessage();
                    this.dataService.post("extuser/register", JSON.stringify(this.user))
                        .subscribe((resp) => {
                                msg.message = resp.Message;
                                this.validationMessage = msg;
                                if (resp.Succeeded == "1") {
                                    this.hasSuccess = true;
                                    msg.messageType = ValidationMessageType.Ok;
                                } else {
                                    msg.messageType = ValidationMessageType.Error;
                                    this.hasSuccess = false;
                                }
                            },
                            (error) => {
                                msg.message = error.message.Message;
                                this.validationMessage = msg;
                                this.hasSuccess = false;
                                msg.messageType = ValidationMessageType.Error;
                            });
                }
            });
    }

    public login()  {
        this.router.navigate(["login"]);
    }

    private checkToken() :boolean {
        let msg = new ValidationMessage();
        this.dataService.post("common/tokenverfication?", JSON.stringify(this.user.Token))
            .subscribe(( resp ) => {
                    if (resp.Succeeded == "1") {
                        this.hasSuccess = false;
                        return false;
                    } else {
                        msg.messageType = ValidationMessageType.Error;
                        this.hasSuccess = true;
                        msg.message = resp.Message;
                        this.validationMessage = msg;
                        return true;
                    }
                },
                ( error ) => {
                    this.hasSuccess = true;
                    msg.messageType = ValidationMessageType.Error;
                    if (error && error._body) {
                        msg.message = error.message.Message;
                    } else {
                        msg.message = "Invalid Token";
                    }
                    this.validationMessage = msg;
                    return true;
            });


        return false;
    }

   private validateSecurityQuestionAndAnswer() {
        let msg = new ValidationMessage();
        let error : boolean = false;
        if ((this.user.SecurityQuestion1 == this.user.SecurityAnswer1) || (this.user.SecurityQuestion2 == this.user.SecurityAnswer2) || (this.user.SecurityQuestion3 == this.user.SecurityAnswer3))
        {
            error = true;
            msg.message = "Security Question and Answer cannot be same";
        }

        if ((this.user.SecurityQuestion1 == this.user.SecurityAnswer1) || (this.user.SecurityQuestion2 == this.user.SecurityAnswer2) || (this.user.SecurityQuestion3 == this.user.sSecurityAnswer3))
        {
            error = true;
            msg.message = "Security Question and Answer cannot be repeated";
        }

        if (error) {
            this.validationMessage = msg;
            this.hasSuccess = false;
            msg.messageType = ValidationMessageType.Error;
            return false;
        }
        else
        {
            return true;
        }
    }
}
